import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { isBlank } from '@ember/utils';
export default class Create extends Component {
    static{
        template(`
		<input
			class="new-todo"
			{{on "keydown" this.createTodo}}
			aria-label="What needs to be done?"
			placeholder="What needs to be done?"
			{{! template-lint-disable no-autofocus-attribute }}
			autofocus
		/>
	`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @service
    repo;
    // TODO: we should use a <form> instead of this.
    //       this logic was copied from "the old way"
    //       which was Ember 3.2, and todomvc has historically
    //       been not great for a11y
    createTodo = (event1)=>{
        let { keyCode: keyCode1, target: target1 } = event1;
        let value1 = target1.value.trim();
        if (keyCode1 === 13 && !isBlank(value1)) {
            this.repo.add({
                title: value1,
                completed: false
            });
            target1.value = '';
        }
    };
}
